import React, { createContext, useContext, useState } from 'react';
import { EngagementPoint } from '@/hooks/useEngagementPoints';

interface EngagementPointDialogContextType {
  isOpen: boolean;
  editingEngagementPoint: EngagementPoint | null;
  openAddEngagementPoint: () => void;
  openEditEngagementPoint: (point: EngagementPoint) => void;
  closeEngagementPointDialog: () => void;
}

const EngagementPointDialogContext = createContext<EngagementPointDialogContextType | undefined>(undefined);

export const EngagementPointDialogProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [editingEngagementPoint, setEditingEngagementPoint] = useState<EngagementPoint | null>(null);

  const openAddEngagementPoint = () => {
    setEditingEngagementPoint(null);
    setIsOpen(true);
  };

  const openEditEngagementPoint = (point: EngagementPoint) => {
    setEditingEngagementPoint(point);
    setIsOpen(true);
  };

  const closeEngagementPointDialog = () => {
    setIsOpen(false);
    setEditingEngagementPoint(null);
  };

  return (
    <EngagementPointDialogContext.Provider 
      value={{ 
        isOpen, 
        editingEngagementPoint, 
        openAddEngagementPoint, 
        openEditEngagementPoint, 
        closeEngagementPointDialog 
      }}
    >
      {children}
    </EngagementPointDialogContext.Provider>
  );
};

export const useEngagementPointDialog = () => {
  const context = useContext(EngagementPointDialogContext);
  if (context === undefined) {
    throw new Error('useEngagementPointDialog must be used within an EngagementPointDialogProvider');
  }
  return context;
};
